import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";
import { Value } from "devextreme-react/range-selector";
import { logDebugSilently } from "../../../modules/logger";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;
  children?: React.ReactNode;
  step?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  showWhenIsDisabled?: boolean;
  min?: number;
  max?: number;
  tooltipCallBack?: () => string | undefined;
}

const NumberEditorLegacy = ({ label, fieldName, formHook, options, step, children, tooltipId, isDisabled, showWhenIsDisabled, min, max, tooltipCallBack }: IProps) => {
  const { register, formState, resetField, unregister } = formHook;
  const globalData = useGlobalData();

  const errors = formState.errors;
  const isInValid: any = getValueByString(errors, fieldName);

  if (label === "Vid reducerat flöde med reglerbara rumsdon- ange normal andel av aggregatets maxflöde (%)") {
    logDebugSilently("NumberEditor.tsx: isInValid: ", isInValid);
  }

  options = options || {};
  if (options) {
    if (!options.valueAsNumber && !options.setValueAs) options.valueAsNumber = true;
  }

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipCallBack)
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{tooltipCallBack()}</span>
        </Tooltip>
      );
    else if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const getNumberEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <div className={(children ? "input-group" : "") + " w-100"}>
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          {isDisabled ? (
            showWhenIsDisabled ? (
              <input id={label} type="number" disabled={true} {...register(fieldName, {})} className="form-control" />
            ) : (
              <input value={""} type="number" disabled={true} className={"form-control"} />
            )
          ) : (
            <input id={label} type="number" min={min} max={max} step={step} disabled={isDisabled} {...register(fieldName, options)} className={"form-control " + (isInValid ? "is-invalid" : "")} />
          )}
        </OverlayTrigger>

        {children}
        {/* {errors[fieldName]?.message && <div className="invalid-feedback">{errors[fieldName]?.message?.toString()}</div>} */}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getNumberEditor()}</>;
};

export default NumberEditorLegacy;
